export default {
  US: [
    {
      label: 'Alabama',
      value: 'AL',
      city: [
        { label: 'Gadsden', lat: '34.01', lng: '-86.01' },
        { label: 'Moundville', lat: '32.99', lng: '-87.63' },
        { label: 'Florence', lat: '34.82', lng: '-87.66' },
        { label: 'Cottonton', lat: '32.13', lng: '-85.14' },
        { label: 'Jasper', lat: '33.85', lng: '-87.27' },
        { label: 'Chapman', lat: '31.66', lng: '-86.72' },
        { label: 'Selma', lat: '32.41', lng: '-87.03' },
        { label: 'Anniston', lat: '33.66', lng: '-85.81' },
        { label: 'Cullman', lat: '34.17', lng: '-86.83' },
        { label: 'Hanceville', lat: '34.06', lng: '-86.76' },
        { label: 'Muscle Shoals', lat: '34.74', lng: '-87.64' },
        { label: 'Opelika', lat: '32.65', lng: '-85.37' },
        { label: 'Jackson', lat: '31.34', lng: '-87.84' },
        { label: 'Decatur', lat: '34.57', lng: '-86.98' },
        { label: 'Tuscaloosa', lat: '33.23', lng: '-87.54' },
        { label: 'Huntsville', lat: '34.7', lng: '-86.62' },
        { label: 'Mobile', lat: '30.68', lng: '-88.04' },
        { label: 'Dothan', lat: '31.23', lng: '-85.4' },
        { label: 'Birmingham', lat: '33.52', lng: '-86.79' },
        { label: 'Montgomery', lat: '32.35', lng: '-86.28' }
      ]
    },
    {
      label: 'Alaska',
      value: 'AK',
      city: [
        { label: 'Fairbanks', lat: '64.81', lng: '-147.72' },
        { label: 'Togiak', lat: '59.21', lng: '-160.54' },
        { label: 'Palmer', lat: '61.6', lng: '-148.46' },
        { label: 'Cantwell', lat: '63.33', lng: '-148.33' },
        { label: 'Port Lions', lat: '57.9', lng: '-153.04' },
        { label: 'Wales', lat: '65.61', lng: '-168.09' },
        { label: 'Kenai', lat: '60.66', lng: '-150.9' },
        { label: 'Soldotna', lat: '60.32', lng: '-150.79' },
        { label: 'Kasigluk', lat: '60.87', lng: '-162.54' },
        { label: 'Emmonak', lat: '62.69', lng: '-162.96' },
        { label: 'Wasilla', lat: '61.61', lng: '-149.58' },
        { label: 'Eagle River', lat: '61.21', lng: '-149.25' },
        { label: 'Ambler', lat: '67.08', lng: '-157.9' },
        { label: 'Sitka', lat: '56.73', lng: '-135' },
        { label: 'Juneau', lat: '58.58', lng: '-134.77' },
        { label: 'Ketchikan', lat: '55.61', lng: '-131.58' },
        { label: 'Homer', lat: '59.4', lng: '-151.32' },
        { label: 'Kodiak', lat: '57.79', lng: '-152.4' },
        { label: 'Willow', lat: '62.69', lng: '-151.07' },
        { label: 'Anchorage', lat: '61.22', lng: '-149.85' }
      ]
    },
    {
      label: 'Arizona',
      value: 'AZ',
      city: [
        { label: 'Prescott', lat: '34.62', lng: '-112.42' },
        { label: 'Lake Havasu City', lat: '34.48', lng: '-114.32' },
        { label: 'Ash Fork', lat: '35.13', lng: '-112.52' },
        { label: 'Gila Bend', lat: '32.99', lng: '-112.9' },
        { label: 'Poston', lat: '34', lng: '-114.4' },
        { label: 'Phoenix', lat: '33.45', lng: '-112.06' },
        { label: 'Gilbert', lat: '33.34', lng: '-111.81' },
        { label: 'Flagstaff', lat: '35.23', lng: '-111.72' },
        { label: 'Tempe', lat: '33.4', lng: '-111.92' },
        { label: 'Nogales', lat: '31.45', lng: '-110.83' },
        { label: 'Yuma', lat: '32.68', lng: '-114.66' },
        { label: 'Chandler', lat: '33.32', lng: '-111.87' },
        { label: 'Tucson', lat: '32.21', lng: '-110.96' },
        { label: 'Kingman', lat: '35.24', lng: '-113.76' },
        { label: 'Casa Grande', lat: '32.91', lng: '-111.74' },
        { label: 'Tolleson', lat: '33.42', lng: '-112.27' },
        { label: 'Scottsdale', lat: '33.53', lng: '-111.89' },
        { label: 'Buckeye', lat: '33.38', lng: '-112.55' },
        { label: 'Glendale', lat: '33.53', lng: '-112.18' },
        { label: 'Mesa', lat: '33.44', lng: '-111.85' }
      ]
    },
    {
      label: 'Arkansas',
      value: 'AR',
      city: [
        { label: 'Leola', lat: '34.16', lng: '-92.59' },
        { label: 'Bentonville', lat: '36.36', lng: '-94.2' },
        { label: 'Hope', lat: '33.66', lng: '-93.59' },
        { label: 'Huttig', lat: '33.04', lng: '-92.18' },
        { label: 'Conway', lat: '35.08', lng: '-92.45' },
        { label: 'Magnolia', lat: '33.27', lng: '-93.23' },
        { label: 'Fayetteville', lat: '36.04', lng: '-94.24' },
        { label: 'Ola', lat: '35.03', lng: '-93.22' },
        { label: 'Hot Springs', lat: '34.5', lng: '-93.05' },
        { label: 'Bearden', lat: '33.72', lng: '-92.61' },
        { label: 'Rogers', lat: '36.33', lng: '-94.13' },
        { label: 'Little Rock', lat: '34.72', lng: '-92.35' },
        { label: 'Fort Smith', lat: '35.36', lng: '-94.38' },
        { label: 'Jonesboro', lat: '35.82', lng: '-90.68' },
        { label: 'Russellville', lat: '35.27', lng: '-93.14' },
        { label: 'North Little Rock', lat: '34.72', lng: '-92.35' },
        { label: 'Warren', lat: '33.61', lng: '-92.06' },
        { label: 'Pine Bluff', lat: '34.21', lng: '-92.01' },
        { label: 'Springdale', lat: '36.18', lng: '-94.14' },
        { label: 'Waldo', lat: '33.35', lng: '-93.29' }
      ]
    },
    {
      label: 'California',
      value: 'CA',
      city: [
        { label: 'Weaverville', lat: '40.74', lng: '-122.93' },
        { label: 'American Canyon', lat: '38.18', lng: '-122.25' },
        { label: 'Chester', lat: '40.27', lng: '-121.24' },
        { label: 'Santa Rosa', lat: '38.44', lng: '-122.78' },
        { label: 'Los Angeles', lat: '33.99', lng: '-118.39' },
        { label: 'Redding', lat: '40.6', lng: '-122.46' },
        { label: 'Oakland', lat: '37.77', lng: '-122.21' },
        { label: 'Santa Maria', lat: '34.91', lng: '-120.23' },
        { label: 'Stockton', lat: '37.9', lng: '-121.22' },
        { label: 'San Jose', lat: '37.38', lng: '-121.89' },
        { label: 'Long Beach', lat: '33.82', lng: '-118.26' },
        { label: 'Salinas', lat: '36.64', lng: '-121.62' },
        { label: 'Fresno', lat: '36.83', lng: '-119.79' },
        { label: 'Sacramento', lat: '38.58', lng: '-121.49' },
        { label: 'Brawley', lat: '33.02', lng: '-115.45' },
        { label: 'San Diego', lat: '32.71', lng: '-117.16' },
        { label: 'San Francisco', lat: '37.77', lng: '-122.41' },
        { label: 'Bakersfield', lat: '35.38', lng: '-119.02' },
        { label: 'Riverside', lat: '33.99', lng: '-117.38' }
      ]
    },
    {
      label: 'Colorado',
      value: 'CO',
      city: [
        { label: 'Boulder', lat: '40.02', lng: '-105.25' },
        { label: 'Center', lat: '37.75', lng: '-106.11' },
        { label: 'Rifle', lat: '39.53', lng: '-107.77' },
        { label: 'Littleton', lat: '39.59', lng: '-105.01' },
        { label: 'Walden', lat: '40.57', lng: '-106.43' },
        { label: 'Alamosa', lat: '37.46', lng: '-105.87' },
        { label: 'Lakewood', lat: '39.76', lng: '-104.87' },
        { label: 'Denver', lat: '39.82', lng: '-105.1' },
        { label: 'Golden', lat: '39.8', lng: '-105.49' },
        { label: 'Cortez', lat: '37.35', lng: '-108.57' },
        { label: 'Grand Junction', lat: '39.08', lng: '-108.55' },
        { label: 'Aurora', lat: '39.69', lng: '-104.81' },
        { label: 'Englewood', lat: '39.76', lng: '-104.87' },
        { label: 'Montrose', lat: '38.49', lng: '-107.87' },
        { label: 'Monte Vista', lat: '37.55', lng: '-106.05' },
        { label: 'Longmont', lat: '40.17', lng: '-105.11' },
        { label: 'Colorado Springs', lat: '38.86', lng: '-104.76' },
        { label: 'Fort Collins', lat: '40.55', lng: '-105.06' },
        { label: 'Pueblo', lat: '38.27', lng: '-104.62' },
        { label: 'Greeley', lat: '40.42', lng: '-104.74' }
      ]
    },
    {
      label: 'Connecticut',
      value: 'CT',
      city: [
        { label: 'Wallingford', lat: '41.44', lng: '-72.81' },
        { label: 'Newington', lat: '41.68', lng: '-72.73' },
        { label: 'Shelton', lat: '41.3', lng: '-73.13' },
        { label: 'Seymour', lat: '41.42', lng: '-73.11' },
        { label: 'Willimantic', lat: '41.71', lng: '-72.21' },
        { label: 'Fairfield', lat: '41.13', lng: '-73.28' },
        { label: 'Westport', lat: '41.12', lng: '-73.34' },
        { label: 'Norwalk', lat: '41.09', lng: '-73.42' },
        { label: 'Greenwich', lat: '41.06', lng: '-73.63' },
        { label: 'Hamden', lat: '41.31', lng: '-72.92' },
        { label: 'Bridgeport', lat: '41.18', lng: '-73.19' },
        { label: 'Southington', lat: '41.6', lng: '-72.88' },
        { label: 'Milford', lat: '41.22', lng: '-73.06' },
        { label: 'Waterbury', lat: '41.55', lng: '-73.03' },
        { label: 'New Haven', lat: '41.31', lng: '-72.92' },
        { label: 'New Britain', lat: '41.67', lng: '-72.78' },
        { label: 'Stamford', lat: '41.09', lng: '-73.55' },
        { label: 'Danbury', lat: '41.4', lng: '-73.47' },
        { label: 'Cheshire', lat: '41.5', lng: '-72.9' },
        { label: 'Hartford', lat: '41.76', lng: '-72.68' }
      ]
    },
    {
      label: 'Delaware',
      value: 'DE',
      city: [
        { label: 'Lincoln', lat: '38.86', lng: '-75.36' },
        { label: 'Bethel', lat: '38.57', lng: '-75.61' },
        { label: 'Millville', lat: '38.54', lng: '-75.11' },
        { label: 'Bear', lat: '39.58', lng: '-75.68' },
        { label: 'Rockland', lat: '39.8', lng: '-75.61' },
        { label: 'Millsboro', lat: '38.58', lng: '-75.29' },
        { label: 'Dover Air Force Base', lat: '39.11', lng: '-75.46' },
        { label: 'Woodside', lat: '39.07', lng: '-75.56' },
        { label: 'Harbeson', lat: '38.67', lng: '-75.23' },
        { label: 'Houston', lat: '38.91', lng: '-75.5' },
        { label: 'Wilmington', lat: '39.73', lng: '-75.53' },
        { label: 'Seaford', lat: '38.64', lng: '-75.61' },
        { label: 'Dover', lat: '39.15', lng: '-75.51' },
        { label: 'Middletown', lat: '39.45', lng: '-75.71' },
        { label: 'Milford', lat: '38.91', lng: '-75.43' },
        { label: 'Rehoboth Beach', lat: '38.7', lng: '-75.09' },
        { label: 'Lewes', lat: '38.76', lng: '-75.17' },
        { label: 'Georgetown', lat: '38.69', lng: '-75.38' },
        { label: 'Newark', lat: '39.67', lng: '-75.75' },
        { label: 'New Castle', lat: '39.66', lng: '-75.57' }
      ]
    },
    {
      label: 'District of Columbia',
      value: 'DC',
      city: [
        { label: 'Washington Navy Yard', lat: '38.89', lng: '-77.03' },
        { label: 'Anacostia', lat: '38.89', lng: '-77.03' },
        { label: 'Fort Mcnair', lat: '38.89', lng: '-77.03' },
        { label: 'Washington', lat: '38.89', lng: '-77.03' }
      ]
    },
    {
      label: 'Florida',
      value: 'FL',
      city: [
        { label: 'Graceville', lat: '30.96', lng: '-85.51' },
        { label: 'Saint Augustine', lat: '29.8', lng: '-81.26' },
        { label: 'Cypress', lat: '30.71', lng: '-85.07' },
        { label: 'Hosford', lat: '30.38', lng: '-84.79' },
        { label: 'Naples', lat: '26.14', lng: '-81.79' },
        { label: 'Boca Raton', lat: '26.37', lng: '-80.1' },
        { label: 'Hialeah', lat: '25.86', lng: '-80.29' },
        { label: 'Lake City', lat: '30.19', lng: '-82.64' },
        { label: 'Jacksonville', lat: '30.33', lng: '-81.65' },
        { label: 'Sarasota', lat: '27.42', lng: '-82.54' },
        { label: 'Marianna', lat: '30.77', lng: '-85.23' },
        { label: 'Tampa', lat: '27.95', lng: '-82.48' },
        { label: 'Cross City', lat: '29.63', lng: '-83.12' },
        { label: 'Miami', lat: '25.86', lng: '-80.29' },
        { label: 'Perry', lat: '30.1', lng: '-83.58' },
        { label: 'Bristol', lat: '30.42', lng: '-84.97' },
        { label: 'Havana', lat: '30.62', lng: '-84.41' },
        { label: 'Ocala', lat: '29.18', lng: '-82.13' },
        { label: 'Orlando', lat: '28.5', lng: '-81.37' },
        { label: 'West Palm Beach', lat: '26.78', lng: '-80.43' }
      ]
    },
    {
      label: 'Georgia',
      value: 'GA',
      city: [
        { label: 'Atlanta', lat: '33.85', lng: '-84.39' },
        { label: 'Decatur', lat: '33.77', lng: '-84.29' },
        { label: 'Roswell', lat: '34.03', lng: '-84.35' },
        { label: 'Metcalf', lat: '30.83', lng: '-83.97' },
        { label: 'Preston', lat: '32.06', lng: '-84.54' },
        { label: 'Thomasville', lat: '30.83', lng: '-83.97' },
        { label: 'Alpharetta', lat: '34.06', lng: '-84.27' },
        { label: 'Blackshear', lat: '31.29', lng: '-82.24' },
        { label: 'Savannah', lat: '32.08', lng: '-81.1' },
        { label: 'Columbus', lat: '32.56', lng: '-84.74' },
        { label: 'Perry', lat: '32.46', lng: '-83.73' },
        { label: 'Norcross', lat: '33.94', lng: '-84.2' },
        { label: 'Lawrenceville', lat: '33.94', lng: '-83.99' },
        { label: 'Marietta', lat: '33.95', lng: '-84.54' },
        { label: 'Fitzgerald', lat: '31.7', lng: '-83.25' },
        { label: 'Macon', lat: '32.83', lng: '-83.65' },
        { label: 'Swainsboro', lat: '32.59', lng: '-82.33' },
        { label: 'Cordele', lat: '31.96', lng: '-83.77' },
        { label: 'Augusta', lat: '33.45', lng: '-81.99' },
        { label: 'Rome', lat: '34.28', lng: '-85.18' }
      ]
    },
    {
      label: 'Hawaii',
      value: 'HI',
      city: []
    },
    {
      label: 'Idaho',
      value: 'ID',
      city: [
        { label: 'Athol', lat: '47.96', lng: '-116.68' },
        { label: 'Saint Maries', lat: '47.2', lng: '-116.55' },
        { label: 'Wendell', lat: '42.74', lng: '-114.73' },
        { label: 'Kooskia', lat: '46.08', lng: '-115.86' },
        { label: 'Garden Valley', lat: '44.08', lng: '-115.85' },
        { label: 'Grangeville', lat: '45.9', lng: '-116.13' },
        { label: 'Jerome', lat: '42.75', lng: '-114.36' },
        { label: 'Princeton', lat: '46.9', lng: '-116.81' },
        { label: 'Pocatello', lat: '42.9', lng: '-112.39' },
        { label: 'Nampa', lat: '43.6', lng: '-116.61' },
        { label: 'Post Falls', lat: '47.78', lng: '-117.02' },
        { label: 'Twin Falls', lat: '42.41', lng: '-114.59' },
        { label: 'Meridian', lat: '43.59', lng: '-116.42' },
        { label: 'Lewiston', lat: '46.16', lng: '-116.92' },
        { label: 'Sandpoint', lat: '48.34', lng: '-116.45' },
        { label: 'Kamiah', lat: '46.25', lng: '-115.96' },
        { label: 'Rexburg', lat: '43.78', lng: '-111.76' },
        { label: 'Boise', lat: '43.62', lng: '-116.32' },
        { label: 'Idaho Falls', lat: '43.5', lng: '-111.89' }
      ]
    },
    {
      label: 'Illinois',
      value: 'IL',
      city: [
        { label: 'Decatur', lat: '39.85', lng: '-88.93' },
        { label: 'Park Ridge', lat: '42.01', lng: '-87.84' },
        { label: 'Chicago', lat: '41.85', lng: '-87.65' },
        { label: 'Arlington Heights', lat: '42.09', lng: '-87.98' },
        { label: 'Mccook', lat: '41.8', lng: '-87.87' },
        { label: 'Peru', lat: '41.34', lng: '-89.12' },
        { label: 'Cairo', lat: '36.99', lng: '-89.17' },
        { label: 'Franklin Park', lat: '41.93', lng: '-87.87' },
        { label: 'Springfield', lat: '39.78', lng: '-89.64' },
        { label: 'Schaumburg', lat: '42.03', lng: '-88.08' },
        { label: 'Joliet', lat: '41.55', lng: '-88.12' },
        { label: 'Rockdale', lat: '41.52', lng: '-88.12' },
        { label: 'Sauget', lat: '38.61', lng: '-90.13' },
        { label: 'Naperville', lat: '41.76', lng: '-88.15' },
        { label: 'Aurora', lat: '41.77', lng: '-88.25' },
        { label: 'Seneca', lat: '41.3', lng: '-88.61' },
        { label: 'Rock Island', lat: '41.47', lng: '-90.58' },
        { label: 'Plano', lat: '41.66', lng: '-88.53' },
        { label: 'Peoria', lat: '40.74', lng: '-89.6' },
        { label: 'Rockford', lat: '42.27', lng: '-89.06' }
      ]
    },
    {
      label: 'Indiana',
      value: 'IN',
      city: [
        { label: 'Mount Vernon', lat: '37.93', lng: '-87.89' },
        { label: 'South Bend', lat: '41.67', lng: '-86.26' },
        { label: 'Laporte', lat: '41.6', lng: '-86.71' },
        { label: 'Troy', lat: '38', lng: '-86.81' },
        { label: 'Michigan City', lat: '41.71', lng: '-86.87' },
        { label: 'Avilla', lat: '41.36', lng: '-85.23' },
        { label: 'Butler', lat: '41.42', lng: '-84.87' },
        { label: 'Evansville', lat: '37.98', lng: '-87.54' },
        { label: 'Elkhart', lat: '41.68', lng: '-85.96' },
        { label: 'Valparaiso', lat: '41.47', lng: '-87.05' },
        { label: 'Waterloo', lat: '41.43', lng: '-85.02' },
        { label: 'Kokomo', lat: '40.47', lng: '-86.13' },
        { label: 'Terre Haute', lat: '39.47', lng: '-87.38' },
        { label: 'Muncie', lat: '40.19', lng: '-85.39' },
        { label: 'Shelbyville', lat: '39.52', lng: '-85.77' },
        { label: 'Bloomington', lat: '39.16', lng: '-86.52' },
        { label: 'Gary', lat: '41.59', lng: '-87.34' },
        { label: 'Indianapolis', lat: '39.77', lng: '-86.14' },
        { label: 'Lafayette', lat: '40.41', lng: '-86.87' },
        { label: 'Fort Wayne', lat: '41.07', lng: '-85.13' }
      ]
    },
    {
      label: 'Iowa',
      value: 'IA',
      city: [
        { label: 'Ackley', lat: '42.55', lng: '-93.05' },
        { label: 'De Witt', lat: '41.82', lng: '-90.54' },
        { label: 'Pacific Junction', lat: '41.01', lng: '-95.79' },
        { label: 'Fertile', lat: '43.26', lng: '-93.42' },
        { label: 'Muscatine', lat: '41.41', lng: '-91.07' },
        { label: 'Grinnell', lat: '41.74', lng: '-92.72' },
        { label: 'Cedar Rapids', lat: '41.97', lng: '-91.66' },
        { label: 'Keokuk', lat: '40.4', lng: '-91.4' },
        { label: 'Urbandale', lat: '41.63', lng: '-93.74' },
        { label: 'Ames', lat: '42.02', lng: '-93.62' },
        { label: 'Clinton', lat: '41.84', lng: '-90.23' },
        { label: 'Council Bluffs', lat: '41.24', lng: '-95.85' },
        { label: 'Dubuque', lat: '42.5', lng: '-90.69' },
        { label: 'West Des Moines', lat: '41.48', lng: '-93.76' },
        { label: 'Iowa City', lat: '41.65', lng: '-91.53' },
        { label: 'Davenport', lat: '41.55', lng: '-90.6' },
        { label: 'Mason City', lat: '43.15', lng: '-93.19' },
        { label: 'Des Moines', lat: '41.57', lng: '-93.61' },
        { label: 'Sioux City', lat: '42.5', lng: '-96.39' },
        { label: 'Waterloo', lat: '42.49', lng: '-92.35' }
      ]
    },
    {
      label: 'Kansas',
      value: 'KS',
      city: [
        { label: 'Ulysses', lat: '37.57', lng: '-101.35' },
        { label: 'Paola', lat: '38.57', lng: '-94.86' },
        { label: 'Overland Park', lat: '38.88', lng: '-94.81' },
        { label: 'Manhattan', lat: '39.19', lng: '-96.59' },
        { label: 'Shawnee Mission', lat: '38.9', lng: '-94.68' },
        { label: 'Hesston', lat: '38.13', lng: '-97.42' },
        { label: 'El Dorado', lat: '37.82', lng: '-96.85' },
        { label: 'Olathe', lat: '38.88', lng: '-94.81' },
        { label: 'Salina', lat: '38.81', lng: '-97.61' },
        { label: 'Hays', lat: '38.87', lng: '-99.31' },
        { label: 'Winfield', lat: '37.26', lng: '-96.96' },
        { label: 'Hutchinson', lat: '38.06', lng: '-97.91' },
        { label: 'Lawrence', lat: '38.96', lng: '-95.25' },
        { label: 'Emporia', lat: '38.41', lng: '-96.19' },
        { label: 'Atchison', lat: '39.56', lng: '-95.13' },
        { label: 'Garden City', lat: '37.97', lng: '-100.86' },
        { label: 'Concordia', lat: '39.57', lng: '-97.66' },
        { label: 'Topeka', lat: '39.03', lng: '-95.69' },
        { label: 'Kansas City', lat: '39.1', lng: '-94.62' },
        { label: 'Wichita', lat: '37.83', lng: '-97.37' }
      ]
    },
    {
      label: 'Kentucky',
      value: 'KY',
      city: [
        { label: 'Sebree', lat: '37.6', lng: '-87.52' },
        { label: 'Elizabethtown', lat: '37.7', lng: '-85.87' },
        { label: 'Calvert City', lat: '37.03', lng: '-88.35' },
        { label: 'Wurtland', lat: '38.57', lng: '-82.82' },
        { label: 'Ashland', lat: '38.45', lng: '-82.64' },
        { label: 'Bonnieville', lat: '37.37', lng: '-85.9' },
        { label: 'Covington', lat: '39.08', lng: '-84.5' },
        { label: 'Glasgow', lat: '36.99', lng: '-85.92' },
        { label: 'Paducah', lat: '37.07', lng: '-88.63' },
        { label: 'Frankfort', lat: '38.19', lng: '-84.86' },
        { label: 'Murray', lat: '36.61', lng: '-88.31' },
        { label: 'Somerset', lat: '37.08', lng: '-84.6' },
        { label: 'Franklin', lat: '36.72', lng: '-86.57' },
        { label: 'Florence', lat: '38.99', lng: '-84.64' },
        { label: 'Richmond', lat: '37.74', lng: '-84.29' },
        { label: 'Henderson', lat: '37.83', lng: '-87.58' },
        { label: 'Owensboro', lat: '37.75', lng: '-87.11' },
        { label: 'Louisville', lat: '38.22', lng: '-85.74' },
        { label: 'Lexington', lat: '38.04', lng: '-84.45' },
        { label: 'Bowling Green', lat: '36.97', lng: '-86.44' }
      ]
    },
    {
      label: 'Louisiana',
      value: 'LA',
      city: [
        { label: 'Ruston', lat: '32.53', lng: '-92.63' },
        { label: 'Florien', lat: '31.44', lng: '-93.45' },
        { label: 'Joyce', lat: '31.89', lng: '-92.39' },
        { label: 'Bogalusa', lat: '30.78', lng: '-89.86' },
        { label: 'Pollock', lat: '31.41', lng: '-92.41' },
        { label: 'Metairie', lat: '29.99', lng: '-90.17' },
        { label: 'Houma', lat: '29.57', lng: '-90.7' },
        { label: 'Oakdale', lat: '30.81', lng: '-92.65' },
        { label: 'Kenner', lat: '29.99', lng: '-90.24' },
        { label: 'Campti', lat: '31.89', lng: '-93.11' },
        { label: 'Lake Charles', lat: '30.21', lng: '-93.2' },
        { label: 'Arcadia', lat: '32.55', lng: '-92.92' },
        { label: 'Shreveport', lat: '32.47', lng: '-93.79' },
        { label: 'Slidell', lat: '30.28', lng: '-89.77' },
        { label: 'Bossier City', lat: '32.51', lng: '-93.66' },
        { label: 'Monroe', lat: '32.51', lng: '-92.08' },
        { label: 'New Orleans', lat: '30.06', lng: '-89.93' },
        { label: 'Alexandria', lat: '31.29', lng: '-92.46' },
        { label: 'Lafayette', lat: '30.21', lng: '-92.02' },
        { label: 'Baton Rouge', lat: '30.44', lng: '-91.12' }
      ]
    },
    {
      label: 'Maine',
      value: 'ME',
      city: [
        { label: 'Kingfield', lat: '44.95', lng: '-70.15' },
        { label: 'Portland', lat: '43.66', lng: '-70.25' },
        { label: 'Belgrade', lat: '44.44', lng: '-69.83' },
        { label: 'Windham', lat: '43.79', lng: '-70.4' },
        { label: 'Westbrook', lat: '43.69', lng: '-70.35' },
        { label: 'South Portland', lat: '43.63', lng: '-70.28' },
        { label: 'Rockland', lat: '44.12', lng: '-69.13' },
        { label: 'Auburn', lat: '44.08', lng: '-70.24' },
        { label: 'Poland Spring', lat: '44.06', lng: '-70.39' },
        { label: 'Houlton', lat: '46.11', lng: '-67.83' },
        { label: 'East Millinocket', lat: '45.62', lng: '-68.57' },
        { label: 'Hollis Center', lat: '43.59', lng: '-70.6' },
        { label: 'Scarborough', lat: '43.59', lng: '-70.33' },
        { label: 'Lewiston', lat: '44.08', lng: '-70.17' },
        { label: 'Augusta', lat: '44.33', lng: '-69.72' },
        { label: 'Poland', lat: '44.06', lng: '-70.39' },
        { label: 'Medway', lat: '45.6', lng: '-68.53' },
        { label: 'Waterville', lat: '44.56', lng: '-69.55' },
        { label: 'Brunswick', lat: '43.91', lng: '-69.96' },
        { label: 'Bangor', lat: '44.83', lng: '-68.78' }
      ]
    },
    {
      label: 'Maryland',
      value: 'MD',
      city: [
        { label: 'Glen Burnie', lat: '39.16', lng: '-76.6' },
        { label: 'Snow Hill', lat: '38.17', lng: '-75.39' },
        { label: 'Silver Spring', lat: '39.01', lng: '-77.02' },
        { label: 'Dickerson', lat: '39.22', lng: '-77.42' },
        { label: 'Belcamp', lat: '39.46', lng: '-76.23' },
        { label: 'Annapolis Junction', lat: '39.12', lng: '-76.77' },
        { label: 'Edgewood', lat: '39.42', lng: '-76.29' },
        { label: 'Rockville', lat: '39.08', lng: '-77.15' },
        { label: 'Annapolis', lat: '38.97', lng: '-76.5' },
        { label: 'Columbia', lat: '38.74', lng: '-76.85' },
        { label: 'Baltimore', lat: '39.3', lng: '-76.61' },
        { label: 'Aberdeen', lat: '39.51', lng: '-76.17' },
        { label: 'Hagerstown', lat: '39.63', lng: '-77.71' },
        { label: 'Bethesda', lat: '38.97', lng: '-77.1' },
        { label: 'Gaithersburg', lat: '39.14', lng: '-77.21' },
        { label: 'Laurel', lat: '39.09', lng: '-76.85' },
        { label: 'Salisbury', lat: '38.37', lng: '-75.58' },
        { label: 'Jessup', lat: '39.14', lng: '-76.77' },
        { label: 'Federalsburg', lat: '38.69', lng: '-75.77' },
        { label: 'Frederick', lat: '39.42', lng: '-77.41' }
      ]
    },
    {
      label: 'Massachusetts',
      value: 'MA',
      city: [
        { label: 'Lynn', lat: '42.47', lng: '-70.96' },
        { label: 'Waltham', lat: '42.38', lng: '-71.24' },
        { label: 'Bondsville', lat: '42.2', lng: '-72.34' },
        { label: 'West Springfield', lat: '42.12', lng: '-72.65' },
        { label: 'Lawrence', lat: '42.7', lng: '-71.16' },
        { label: 'Dorchester', lat: '42.35', lng: '-71.06' },
        { label: 'Newton', lat: '42.33', lng: '-71.2' },
        { label: 'Lowell', lat: '42.63', lng: '-71.32' },
        { label: 'Cambridge', lat: '42.35', lng: '-71.06' },
        { label: 'East Longmeadow', lat: '42.06', lng: '-72.51' },
        { label: 'New Bedford', lat: '41.66', lng: '-70.93' },
        { label: 'Brockton', lat: '42.08', lng: '-71.02' },
        { label: 'Fall River', lat: '41.71', lng: '-71.1' },
        { label: 'Framingham', lat: '42.3', lng: '-71.43' },
        { label: 'Ayer', lat: '42.56', lng: '-71.58' },
        { label: 'Worcester', lat: '42.26', lng: '-71.8' },
        { label: 'Boston', lat: '42.35', lng: '-71.06' },
        { label: 'Leominster', lat: '42.51', lng: '-71.77' },
        { label: 'Taunton', lat: '41.87', lng: '-71.01' },
        { label: 'Springfield', lat: '42.04', lng: '-72.57' }
      ]
    },
    {
      label: 'Michigan',
      value: 'MI',
      city: [
        { label: 'Hartford', lat: '42.2', lng: '-86.16' },
        { label: 'Farmington', lat: '42.46', lng: '-83.37' },
        { label: 'Grand Rapids', lat: '42.96', lng: '-85.65' },
        { label: 'Edwardsburg', lat: '41.79', lng: '-86.08' },
        { label: 'Sandusky', lat: '43.42', lng: '-82.83' },
        { label: 'Paw Paw', lat: '42.21', lng: '-85.89' },
        { label: 'Ann Arbor', lat: '42.27', lng: '-83.73' },
        { label: 'Saginaw', lat: '43.41', lng: '-83.94' },
        { label: 'Flint', lat: '43.02', lng: '-83.69' },
        { label: 'Southfield', lat: '42.46', lng: '-83.28' },
        { label: 'Troy', lat: '42.58', lng: '-83.14' },
        { label: 'Kalamazoo', lat: '42.27', lng: '-85.58' },
        { label: 'Detroit', lat: '42.38', lng: '-83.1' },
        { label: 'Kentwood', lat: '42.96', lng: '-85.65' },
        { label: 'Plymouth', lat: '42.37', lng: '-83.46' },
        { label: 'Imlay City', lat: '43.01', lng: '-83.07' },
        { label: 'Traverse City', lat: '44.75', lng: '-85.6' },
        { label: 'Lansing', lat: '42.7', lng: '-84.55' }
      ]
    },
    {
      label: 'Minnesota',
      value: 'MN',
      city: [
        { label: 'Blue Earth', lat: '43.63', lng: '-94.09' },
        { label: 'Burnsville', lat: '44.76', lng: '-93.27' },
        { label: 'Saint Peter', lat: '44.32', lng: '-93.96' },
        { label: 'Savage', lat: '44.75', lng: '-93.35' },
        { label: 'New Hope', lat: '44.96', lng: '-93.26' },
        { label: 'Duluth', lat: '46.84', lng: '-92.22' },
        { label: 'Randolph', lat: '44.52', lng: '-93.01' },
        { label: 'Eden Prairie', lat: '44.92', lng: '-93.4' },
        { label: 'Edina', lat: '44.92', lng: '-93.4' },
        { label: 'Bloomington', lat: '44.96', lng: '-93.26' },
        { label: 'Brainerd', lat: '46.35', lng: '-94.19' },
        { label: 'Winona', lat: '44.04', lng: '-91.65' },
        { label: 'Saint Cloud', lat: '45.55', lng: '-94.17' },
        { label: 'Albert Lea', lat: '43.65', lng: '-93.36' },
        { label: 'Minneapolis', lat: '44.96', lng: '-93.26' },
        { label: 'Rochester', lat: '44.01', lng: '-92.47' },
        { label: 'East Grand Forks', lat: '47.93', lng: '-97.01' },
        { label: 'Solway', lat: '47.52', lng: '-95.12' },
        { label: 'Lakeville', lat: '44.65', lng: '-93.17' },
        { label: 'Mankato', lat: '44.16', lng: '-93.99' }
      ]
    },
    {
      label: 'Mississippi',
      value: 'MS',
      city: [
        { label: 'Hazlehurst', lat: '31.86', lng: '-90.39' },
        { label: 'Guntown', lat: '34.44', lng: '-88.66' },
        { label: 'Ackerman', lat: '33.31', lng: '-89.17' },
        { label: 'Biloxi', lat: '30.39', lng: '-88.88' },
        { label: 'Ripley', lat: '34.72', lng: '-88.94' },
        { label: 'Jackson', lat: '32.32', lng: '-90.2' },
        { label: 'Forest', lat: '32.35', lng: '-89.47' },
        { label: 'Greenville', lat: '33.38', lng: '-91.05' },
        { label: 'Laurel', lat: '31.69', lng: '-89.14' },
        { label: 'Gulfport', lat: '30.38', lng: '-89.06' },
        { label: 'Hattiesburg', lat: '31.31', lng: '-89.3' },
        { label: 'Columbus', lat: '33.5', lng: '-88.4' },
        { label: 'Brookhaven', lat: '31.58', lng: '-90.44' },
        { label: 'Taylorsville', lat: '31.83', lng: '-89.43' },
        { label: 'Vicksburg', lat: '32.32', lng: '-90.87' },
        { label: 'Meridian', lat: '32.38', lng: '-88.71' },
        { label: 'Natchez', lat: '31.54', lng: '-91.38' },
        { label: 'Brandon', lat: '32.28', lng: '-90' },
        { label: 'Grenada', lat: '33.77', lng: '-89.81' },
        { label: 'Tupelo', lat: '34.26', lng: '-88.73' }
      ]
    },
    {
      label: 'Missouri',
      value: 'MO',
      city: [
        { label: 'Lamar', lat: '37.49', lng: '-94.27' },
        { label: 'Butler', lat: '38.25', lng: '-94.33' },
        { label: 'Arbyrd', lat: '36.05', lng: '-90.24' },
        { label: 'West Plains', lat: '36.74', lng: '-91.86' },
        { label: 'Saint Joseph', lat: '39.76', lng: '-94.85' },
        { label: 'Raymondville', lat: '37.33', lng: '-91.83' },
        { label: 'Columbia', lat: '38.95', lng: '-92.32' },
        { label: 'Perryville', lat: '37.55', lng: '-89.84' },
        { label: 'Florissant', lat: '38.79', lng: '-90.32' },
        { label: 'Carthage', lat: '37.16', lng: '-94.31' },
        { label: 'Lees Summit', lat: '38.91', lng: '-94.38' },
        { label: 'Hayti', lat: '36.23', lng: '-89.74' },
        { label: 'Independence', lat: '39.08', lng: '-94.35' },
        { label: 'Chesterfield', lat: '38.65', lng: '-90.58' },
        { label: 'Saint Louis', lat: '38.63', lng: '-90.24' },
        { label: 'Jefferson City', lat: '38.57', lng: '-92.19' },
        { label: 'Harrisonville', lat: '38.65', lng: '-94.34' },
        { label: 'Joplin', lat: '37.08', lng: '-94.5' },
        { label: 'Kansas City', lat: '39.09', lng: '-94.58' },
        { label: 'Springfield', lat: '37.19', lng: '-93.28' }
      ]
    },
    {
      label: 'Montana',
      value: 'MT',
      city: [
        { label: 'Laurel', lat: '45.6', lng: '-108.68' },
        { label: 'Drummond', lat: '46.65', lng: '-113.24' },
        { label: 'Victor', lat: '46.39', lng: '-114.26' },
        { label: 'Saint Regis', lat: '47.31', lng: '-115.14' },
        { label: 'Stevensville', lat: '46.5', lng: '-114.1' },
        { label: 'Deer Lodge', lat: '46.37', lng: '-112.72' },
        { label: 'Hungry Horse', lat: '48.37', lng: '-114.06' },
        { label: 'Columbia Falls', lat: '48.54', lng: '-114.34' },
        { label: 'Butte', lat: '46', lng: '-112.44' },
        { label: 'Sidney', lat: '47.75', lng: '-104.28' },
        { label: 'Billings', lat: '45.65', lng: '-108.38' },
        { label: 'Townsend', lat: '46.48', lng: '-111.34' },
        { label: 'Great Falls', lat: '47.51', lng: '-111.27' },
        { label: 'Kalispell', lat: '48.19', lng: '-114.38' },
        { label: 'Hamilton', lat: '46.16', lng: '-114.14' },
        { label: 'Superior', lat: '47.05', lng: '-114.97' },
        { label: 'Helena', lat: '46.51', lng: '-112.12' },
        { label: 'Livingston', lat: '45.7', lng: '-110.53' },
        { label: 'Bozeman', lat: '45.77', lng: '-110.93' },
        { label: 'Missoula', lat: '46.85', lng: '-113.99' }
      ]
    },
    {
      label: 'Nebraska',
      value: 'NE',
      city: [
        { label: 'Minatare', lat: '41.81', lng: '-103.5' },
        { label: 'Offutt Air Force Base', lat: '41.11', lng: '-95.9' },
        { label: 'South Sioux City', lat: '42.46', lng: '-96.41' },
        { label: 'Wayne', lat: '42.23', lng: '-97.01' },
        { label: 'Waterloo', lat: '41.28', lng: '-96.28' },
        { label: 'West Point', lat: '41.83', lng: '-96.7' },
        { label: 'Archer', lat: '41.16', lng: '-98.13' },
        { label: 'Bellevue', lat: '41.15', lng: '-95.92' },
        { label: 'North Platte', lat: '41.13', lng: '-100.77' },
        { label: 'Scottsbluff', lat: '41.86', lng: '-103.66' },
        { label: 'Lincoln', lat: '40.81', lng: '-96.68' },
        { label: 'Fremont', lat: '41.44', lng: '-96.49' },
        { label: 'Grand Island', lat: '40.92', lng: '-98.36' },
        { label: 'Columbus', lat: '41.43', lng: '-97.35' },
        { label: 'Hastings', lat: '40.58', lng: '-98.39' },
        { label: 'Kearney', lat: '40.7', lng: '-99.08' },
        { label: 'Plattsmouth', lat: '41', lng: '-95.89' },
        { label: 'Valley', lat: '41.31', lng: '-96.34' },
        { label: 'Norfolk', lat: '42.03', lng: '-97.41' },
        { label: 'Omaha', lat: '41.15', lng: '-95.92' }
      ]
    },
    {
      label: 'Nevada',
      value: 'NV',
      city: [
        { label: 'Elko', lat: '40.95', lng: '-115.79' },
        { label: 'Carlin', lat: '40.52', lng: '-116.36' },
        { label: 'Silver Springs', lat: '39.37', lng: '-119.26' },
        { label: 'Incline Village', lat: '39.25', lng: '-119.95' },
        { label: 'Gardnerville', lat: '38.75', lng: '-119.61' },
        { label: 'Mound House', lat: '39.21', lng: '-119.71' },
        { label: 'Pahrump', lat: '36.25', lng: '-116.01' },
        { label: 'Eureka', lat: '39.82', lng: '-116.19' },
        { label: 'Boulder City', lat: '35.91', lng: '-114.8' },
        { label: 'Yerington', lat: '38.87', lng: '-119.14' },
        { label: 'Fernley', lat: '39.66', lng: '-119.06' },
        { label: 'Winnemucca', lat: '41.12', lng: '-118.05' },
        { label: 'Laughlin', lat: '35.15', lng: '-114.62' },
        { label: 'Carson City', lat: '39.14', lng: '-119.71' },
        { label: 'Fallon', lat: '39.5', lng: '-118.29' },
        { label: 'Sparks', lat: '39.53', lng: '-119.73' },
        { label: 'Las Vegas', lat: '35.88', lng: '-115.04' },
        { label: 'North Las Vegas', lat: '36.21', lng: '-115.12' },
        { label: 'Henderson', lat: '36', lng: '-114.96' },
        { label: 'Reno', lat: '39.52', lng: '-119.81' }
      ]
    },
    {
      label: 'New Hampshire',
      value: 'NH',
      city: [
        { label: 'East Wakefield', lat: '43.64', lng: '-71' },
        { label: 'Rochester', lat: '43.3', lng: '-70.97' },
        { label: 'Laconia', lat: '43.56', lng: '-71.48' },
        { label: 'Derry', lat: '42.89', lng: '-71.28' },
        { label: 'New London', lat: '43.41', lng: '-71.98' },
        { label: 'Boscawen', lat: '43.23', lng: '-71.56' },
        { label: 'Londonderry', lat: '42.89', lng: '-71.28' },
        { label: 'Munsonville', lat: '42.99', lng: '-72.12' },
        { label: 'Wonalancet', lat: '43.87', lng: '-71.28' },
        { label: 'Moultonborough', lat: '43.75', lng: '-71.39' },
        { label: 'Webster', lat: '43.23', lng: '-71.56' },
        { label: 'Alton Bay', lat: '43.48', lng: '-71.24' },
        { label: 'Keene', lat: '42.95', lng: '-72.29' },
        { label: 'Bedford', lat: '42.95', lng: '-71.5' },
        { label: 'Newton', lat: '42.86', lng: '-71.03' },
        { label: 'Dover', lat: '43.19', lng: '-70.87' },
        { label: 'Manchester', lat: '42.99', lng: '-71.45' },
        { label: 'Nashua', lat: '42.74', lng: '-71.49' },
        { label: 'Portsmouth', lat: '43.05', lng: '-70.78' },
        { label: 'Concord', lat: '43.23', lng: '-71.56' }
      ]
    },
    {
      label: 'New Jersey',
      value: 'NJ',
      city: [
        { label: 'Hackensack', lat: '40.88', lng: '-74.04' },
        { label: 'Morristown', lat: '40.79', lng: '-74.47' },
        { label: 'Lyndhurst', lat: '40.79', lng: '-74.11' },
        { label: 'Bridgeton', lat: '39.42', lng: '-75.22' },
        { label: 'Avenel', lat: '40.58', lng: '-74.27' },
        { label: 'Allentown', lat: '40.17', lng: '-74.58' },
        { label: 'Edison', lat: '40.52', lng: '-74.36' },
        { label: 'Jersey City', lat: '40.71', lng: '-74.06' },
        { label: 'Toms River', lat: '39.95', lng: '-74.18' },
        { label: 'Freehold', lat: '40.25', lng: '-74.27' },
        { label: 'Princeton', lat: '40.35', lng: '-74.65' },
        { label: 'Elizabeth', lat: '40.66', lng: '-74.19' },
        { label: 'Clifton', lat: '40.86', lng: '-74.15' },
        { label: 'Monroe Township', lat: '40.34', lng: '-74.44' },
        { label: 'Camden', lat: '39.93', lng: '-75.1' },
        { label: 'Paterson', lat: '40.91', lng: '-74.16' },
        { label: 'Trenton', lat: '40.22', lng: '-74.76' },
        { label: 'Cherry Hill', lat: '39.9', lng: '-74.99' },
        { label: 'Vineland', lat: '39.46', lng: '-74.99' },
        { label: 'Newark', lat: '40.72', lng: '-74.17' }
      ]
    },
    {
      label: 'New Mexico',
      value: 'NM',
      city: [
        { label: 'Cuba', lat: '36.02', lng: '-106.95' },
        { label: 'Floyd', lat: '34.21', lng: '-103.54' },
        { label: 'Hatch', lat: '32.66', lng: '-107.15' },
        { label: 'Santa Fe', lat: '35.67', lng: '-105.95' },
        { label: 'Gallup', lat: '35.52', lng: '-108.73' },
        { label: 'Arrey', lat: '32.84', lng: '-107.31' },
        { label: 'Alamogordo', lat: '32.88', lng: '-105.95' },
        { label: 'Taos', lat: '36.38', lng: '-105.57' },
        { label: 'Deming', lat: '32.26', lng: '-107.75' },
        { label: 'Vado', lat: '32.16', lng: '-106.69' },
        { label: 'Portales', lat: '33.78', lng: '-103.11' },
        { label: 'Rio Rancho', lat: '35.27', lng: '-106.66' },
        { label: 'Belen', lat: '34.65', lng: '-106.77' },
        { label: 'Roswell', lat: '33.37', lng: '-104.52' },
        { label: 'Hobbs', lat: '32.73', lng: '-103.16' },
        { label: 'Albuquerque', lat: '35.11', lng: '-106.62' },
        { label: 'Las Cruces', lat: '32.33', lng: '-106.75' },
        { label: 'Carlsbad', lat: '32.4', lng: '-104.23' },
        { label: 'Clovis', lat: '34.41', lng: '-103.2' },
        { label: 'Farmington', lat: '36.75', lng: '-108.18' }
      ]
    },
    {
      label: 'New York',
      value: 'NY',
      city: [
        { label: 'Mount Vernon', lat: '40.91', lng: '-73.82' },
        { label: 'Silver Springs', lat: '42.66', lng: '-78.08' },
        { label: 'Flushing', lat: '40.77', lng: '-73.84' },
        { label: 'Elmira', lat: '42.08', lng: '-76.8' },
        { label: 'Hartford', lat: '43.35', lng: '-73.4' },
        { label: 'Elmira Heights', lat: '42.08', lng: '-76.8' },
        { label: 'Wading River', lat: '40.94', lng: '-72.81' },
        { label: 'Hudson', lat: '42.25', lng: '-73.78' },
        { label: 'Watkins Glen', lat: '42.38', lng: '-76.87' },
        { label: 'Angola', lat: '42.63', lng: '-79.02' },
        { label: 'Dunkirk', lat: '42.47', lng: '-79.33' },
        { label: 'West Babylon', lat: '40.71', lng: '-73.35' },
        { label: 'Rochester', lat: '43.16', lng: '-77.61' },
        { label: 'Buffalo', lat: '42.88', lng: '-78.85' },
        { label: 'Jamaica', lat: '40.68', lng: '-73.78' },
        { label: 'New York', lat: '40.71', lng: '-73.99' },
        { label: 'Albany', lat: '42.66', lng: '-73.79' },
        { label: 'Bronx', lat: '40.84', lng: '-73.87' },
        { label: 'Syracuse', lat: '43.04', lng: '-76.14' },
        { label: 'Staten Island', lat: '40.58', lng: '-74.14' }
      ]
    },
    {
      label: 'North Carolina',
      value: 'NC',
      city: [
        { label: 'Winston-salem', lat: '36.1', lng: '-80.24' },
        { label: 'Louisburg', lat: '36.1', lng: '-78.29' },
        { label: 'Asheville', lat: '35.57', lng: '-82.54' },
        { label: 'Charlotte', lat: '35.19', lng: '-80.83' },
        { label: 'Cofield', lat: '36.35', lng: '-76.9' },
        { label: 'Cary', lat: '35.78', lng: '-78.79' },
        { label: 'Seaboard', lat: '36.49', lng: '-77.44' },
        { label: 'Gastonia', lat: '35.25', lng: '-81.17' },
        { label: 'Eden', lat: '36.5', lng: '-79.74' },
        { label: 'Moncure', lat: '35.62', lng: '-79.08' },
        { label: 'Hickory', lat: '35.73', lng: '-81.32' },
        { label: 'Goldsboro', lat: '35.37', lng: '-77.97' },
        { label: 'Raleigh', lat: '35.82', lng: '-78.65' },
        { label: 'Roxboro', lat: '36.4', lng: '-78.98' },
        { label: 'New London', lat: '35.44', lng: '-80.21' },
        { label: 'Greenville', lat: '35.59', lng: '-77.37' },
        { label: 'Greensboro', lat: '36.07', lng: '-79.82' },
        { label: 'Fayetteville', lat: '35.05', lng: '-78.87' },
        { label: 'Durham', lat: '35.98', lng: '-78.91' },
        { label: 'Wilmington', lat: '34.21', lng: '-77.91' }
      ]
    },
    {
      label: 'North Dakota',
      value: 'ND',
      city: [
        { label: 'Tuttle', lat: '47.14', lng: '-99.99' },
        { label: 'Enderlin', lat: '46.62', lng: '-97.59' },
        { label: 'Glen Ullin', lat: '46.81', lng: '-101.83' },
        { label: 'Amenia', lat: '47', lng: '-97.22' },
        { label: 'Devils Lake', lat: '48.11', lng: '-98.87' },
        { label: 'Grafton', lat: '48.41', lng: '-97.4' },
        { label: 'West Fargo', lat: '46.87', lng: '-96.89' },
        { label: 'Hebron', lat: '46.9', lng: '-102.04' },
        { label: 'Ellendale', lat: '46', lng: '-98.52' },
        { label: 'Fargo', lat: '46.87', lng: '-96.81' },
        { label: 'Mandan', lat: '46.82', lng: '-100.88' },
        { label: 'Grand Forks', lat: '47.91', lng: '-97.07' },
        { label: 'Dickinson', lat: '46.88', lng: '-102.78' },
        { label: 'Jamestown', lat: '46.91', lng: '-98.69' },
        { label: 'Wahpeton', lat: '46.26', lng: '-96.6' },
        { label: 'Mckenzie', lat: '46.81', lng: '-100.28' },
        { label: 'Valley City', lat: '46.92', lng: '-98' },
        { label: 'Williston', lat: '48.16', lng: '-103.63' },
        { label: 'Bismarck', lat: '46.8', lng: '-100.76' },
        { label: 'Minot', lat: '48.23', lng: '-101.29' }
      ]
    },
    {
      label: 'Ohio',
      value: 'OH',
      city: [
        { label: 'Portsmouth', lat: '38.75', lng: '-82.95' },
        { label: 'Pioneer', lat: '41.67', lng: '-84.55' },
        { label: 'Toledo', lat: '41.66', lng: '-83.58' },
        { label: 'Bergholz', lat: '40.52', lng: '-80.88' },
        { label: 'Columbus', lat: '39.98', lng: '-82.98' },
        { label: 'Trenton', lat: '39.47', lng: '-84.46' },
        { label: 'Hamilton', lat: '39.39', lng: '-84.56' },
        { label: 'Mansfield', lat: '40.76', lng: '-82.52' },
        { label: 'Dayton', lat: '40.19', lng: '-84.79' },
        { label: 'Warren', lat: '41.23', lng: '-80.81' },
        { label: 'Fremont', lat: '41.35', lng: '-83.11' },
        { label: 'Springfield', lat: '39.92', lng: '-83.79' },
        { label: 'Massillon', lat: '40.78', lng: '-81.52' },
        { label: 'Akron', lat: '41.08', lng: '-81.52' },
        { label: 'Middletown', lat: '39.55', lng: '-84.3' },
        { label: 'Canton', lat: '40.81', lng: '-81.37' },
        { label: 'Youngstown', lat: '41.09', lng: '-80.64' },
        { label: 'Cincinnati', lat: '39.09', lng: '-84.51' },
        { label: 'Cleveland', lat: '41.47', lng: '-81.67' },
        { label: 'South Charleston', lat: '39.82', lng: '-83.64' }
      ]
    },
    {
      label: 'Oklahoma',
      value: 'OK',
      city: [
        { label: 'Wagoner', lat: '35.95', lng: '-95.38' },
        { label: 'Miami', lat: '36.88', lng: '-94.87' },
        { label: 'Madill', lat: '34.09', lng: '-96.77' },
        { label: 'Ada', lat: '34.77', lng: '-96.66' },
        { label: 'Bartlesville', lat: '36.73', lng: '-95.94' },
        { label: 'Shawnee', lat: '35.33', lng: '-96.91' },
        { label: 'Broken Bow', lat: '34.02', lng: '-94.73' },
        { label: 'Cameron', lat: '35.13', lng: '-94.53' },
        { label: 'Stillwater', lat: '36.13', lng: '-97.07' },
        { label: 'Pryor', lat: '36.3', lng: '-95.32' },
        { label: 'Oklahoma City', lat: '35.46', lng: '-97.51' },
        { label: 'Broken Arrow', lat: '36.03', lng: '-95.78' },
        { label: 'Harrah', lat: '35.48', lng: '-97.18' },
        { label: 'Lawton', lat: '34.6', lng: '-98.42' },
        { label: 'Durant', lat: '33.98', lng: '-96.39' },
        { label: 'Tulsa', lat: '36.12', lng: '-95.91' },
        { label: 'Claremore', lat: '36.31', lng: '-95.61' },
        { label: 'Edmond', lat: '35.67', lng: '-97.41' },
        { label: 'Norman', lat: '35.22', lng: '-97.34' },
        { label: 'Muskogee', lat: '35.74', lng: '-95.35' }
      ]
    },
    {
      label: 'Oregon',
      value: 'OR',
      city: [
        { label: 'Cave Junction', lat: '42.11', lng: '-123.6' },
        { label: 'Medford', lat: '42.28', lng: '-122.9' },
        { label: 'Noti', lat: '44.09', lng: '-123.48' },
        { label: 'Brookings', lat: '42.13', lng: '-124.24' },
        { label: 'Molalla', lat: '45.07', lng: '-122.55' },
        { label: 'Lake Oswego', lat: '45.4', lng: '-122.68' },
        { label: 'Hillsboro', lat: '45.52', lng: '-122.85' },
        { label: 'Beaverton', lat: '45.49', lng: '-122.8' },
        { label: 'Dillard', lat: '43.16', lng: '-123.45' },
        { label: 'Glendale', lat: '42.79', lng: '-123.4' },
        { label: 'Lakeview', lat: '42.38', lng: '-120.2' },
        { label: 'Salem', lat: '44.9', lng: '-122.92' },
        { label: 'Corvallis', lat: '44.63', lng: '-123.27' },
        { label: 'Portland', lat: '45.44', lng: '-122.52' },
        { label: 'Roseburg', lat: '43.21', lng: '-123.4' },
        { label: 'Klamath Falls', lat: '42.31', lng: '-122.07' },
        { label: 'Bend', lat: '44.07', lng: '-121.25' },
        { label: 'Riddle', lat: '42.91', lng: '-123.43' },
        { label: 'Eugene', lat: '44.06', lng: '-123.08' },
        { label: 'Grants Pass', lat: '42.53', lng: '-123.34' }
      ]
    },
    {
      label: 'Pennsylvania',
      value: 'PA',
      city: [
        { label: 'Spring Grove', lat: '39.85', lng: '-76.88' },
        { label: 'Mcmurray', lat: '40.26', lng: '-80.18' },
        { label: 'Emlenton', lat: '41.18', lng: '-79.7' },
        { label: 'York', lat: '40', lng: '-76.84' },
        { label: 'Oxford', lat: '39.78', lng: '-75.98' },
        { label: 'Avondale', lat: '39.82', lng: '-75.78' },
        { label: 'West Chester', lat: '39.95', lng: '-75.6' },
        { label: 'Lancaster', lat: '40.01', lng: '-76.16' },
        { label: 'Bethlehem', lat: '40.62', lng: '-75.36' },
        { label: 'Philadelphia', lat: '39.95', lng: '-75.16' },
        { label: 'Reading', lat: '40.33', lng: '-75.92' },
        { label: 'Erie', lat: '42.12', lng: '-80.08' },
        { label: 'Sellersville', lat: '40.36', lng: '-75.3' },
        { label: 'Myerstown', lat: '40.37', lng: '-76.3' },
        { label: 'Milesburg', lat: '40.94', lng: '-77.79' },
        { label: 'Breinigsville', lat: '40.55', lng: '-75.66' },
        { label: 'Scranton', lat: '41.45', lng: '-75.59' },
        { label: 'Pittsburgh', lat: '40.35', lng: '-79.9' },
        { label: 'Harrisburg', lat: '40.27', lng: '-76.88' },
        { label: 'Allentown', lat: '40.59', lng: '-75.47' }
      ]
    },
    {
      label: 'Rhode Island',
      value: 'RI',
      city: [
        { label: 'West Kingston', lat: '41.5', lng: '-71.59' },
        { label: 'North Providence', lat: '41.82', lng: '-71.41' },
        { label: 'Lincoln', lat: '41.95', lng: '-71.45' },
        { label: 'Johnston', lat: '41.81', lng: '-71.46' },
        { label: 'Exeter', lat: '41.56', lng: '-71.68' },
        { label: 'Slocum', lat: '41.52', lng: '-71.54' },
        { label: 'Mapleville', lat: '41.97', lng: '-71.69' },
        { label: 'Bristol', lat: '41.67', lng: '-71.27' },
        { label: 'Kenyon', lat: '41.48', lng: '-71.68' },
        { label: 'Manville', lat: '41.96', lng: '-71.47' },
        { label: 'Westerly', lat: '41.39', lng: '-71.75' },
        { label: 'Newport', lat: '41.47', lng: '-71.3' },
        { label: 'Pawtucket', lat: '41.87', lng: '-71.37' },
        { label: 'East Greenwich', lat: '41.63', lng: '-71.5' },
        { label: 'Coventry', lat: '41.68', lng: '-71.66' },
        { label: 'North Kingstown', lat: '41.55', lng: '-71.46' },
        { label: 'Providence', lat: '41.82', lng: '-71.41' },
        { label: 'Woonsocket', lat: '41.99', lng: '-71.5' },
        { label: 'Cranston', lat: '41.73', lng: '-71.54' },
        { label: 'Warwick', lat: '41.63', lng: '-71.5' }
      ]
    },
    {
      label: 'South Carolina',
      value: 'SC',
      city: [
        { label: 'Hilton Head Island', lat: '32.12', lng: '-80.86' },
        { label: 'Chester', lat: '34.7', lng: '-81.21' },
        { label: 'Estill', lat: '32.75', lng: '-81.24' },
        { label: 'Fairfax', lat: '32.95', lng: '-81.23' },
        { label: 'Columbia', lat: '34', lng: '-81.03' },
        { label: 'Greenville', lat: '34.83', lng: '-82.37' },
        { label: 'North Charleston', lat: '32.78', lng: '-79.99' },
        { label: 'Effingham', lat: '34.05', lng: '-79.75' },
        { label: 'Bennettsville', lat: '34.63', lng: '-79.68' },
        { label: 'Summerville', lat: '33', lng: '-80.17' },
        { label: 'Spartanburg', lat: '34.94', lng: '-81.92' },
        { label: 'Myrtle Beach', lat: '33.69', lng: '-78.89' },
        { label: 'Mount Pleasant', lat: '32.82', lng: '-79.86' },
        { label: 'Anderson', lat: '34.51', lng: '-82.64' },
        { label: 'Sumter', lat: '33.94', lng: '-80.39' },
        { label: 'Newberry', lat: '34.27', lng: '-81.61' },
        { label: 'Huger', lat: '33.09', lng: '-79.8' },
        { label: 'Florence', lat: '34.18', lng: '-79.78' },
        { label: 'Charleston', lat: '32.78', lng: '-79.99' },
        { label: 'Rock Hill', lat: '34.93', lng: '-81.02' }
      ]
    },
    {
      label: 'South Dakota',
      value: 'SD',
      city: [
        { label: 'Veblen', lat: '45.86', lng: '-97.28' },
        { label: 'Hot Springs', lat: '43.43', lng: '-103.48' },
        { label: 'Lennox', lat: '43.35', lng: '-96.89' },
        { label: 'Huron', lat: '44.36', lng: '-98.21' },
        { label: 'Pierre', lat: '44.37', lng: '-100.32' },
        { label: 'Springfield', lat: '42.85', lng: '-97.89' },
        { label: 'Madison', lat: '44', lng: '-97.1' },
        { label: 'Viborg', lat: '43.17', lng: '-97.08' },
        { label: 'Hill City', lat: '43.93', lng: '-103.57' },
        { label: 'Vermillion', lat: '42.78', lng: '-96.92' },
        { label: 'Aberdeen', lat: '45.46', lng: '-98.48' },
        { label: 'Mitchell', lat: '43.73', lng: '-98.03' },
        { label: 'Sioux Falls', lat: '43.54', lng: '-96.73' },
        { label: 'Yankton', lat: '42.88', lng: '-97.39' },
        { label: 'Brookings', lat: '44.3', lng: '-96.78' },
        { label: 'Belle Fourche', lat: '44.66', lng: '-103.85' },
        { label: 'Piedmont', lat: '44.23', lng: '-103.4' },
        { label: 'Rapid City', lat: '44.07', lng: '-103.23' },
        { label: 'Spearfish', lat: '44.48', lng: '-103.84' },
        { label: 'Watertown', lat: '44.91', lng: '-97.16' }
      ]
    },
    {
      label: 'Tennessee',
      value: 'TN',
      city: [
        { label: 'Gleason', lat: '36.21', lng: '-88.61' },
        { label: 'Brentwood', lat: '35.99', lng: '-86.78' },
        { label: 'Mcminnville', lat: '35.68', lng: '-85.77' },
        { label: 'Reagan', lat: '35.51', lng: '-88.35' },
        { label: 'Halls', lat: '35.88', lng: '-89.4' },
        { label: 'Johnson City', lat: '36.33', lng: '-82.36' },
        { label: 'Knoxville', lat: '35.97', lng: '-83.94' },
        { label: 'Dyersburg', lat: '36.03', lng: '-89.38' },
        { label: 'Memphis', lat: '35.08', lng: '-89.79' },
        { label: 'Jackson', lat: '35.63', lng: '-88.82' },
        { label: 'Franklin', lat: '35.92', lng: '-86.84' },
        { label: 'Clarksville', lat: '36.56', lng: '-87.34' },
        { label: 'Gallatin', lat: '36.37', lng: '-86.45' },
        { label: 'Murfreesboro', lat: '35.85', lng: '-86.39' },
        { label: 'Cleveland', lat: '35.17', lng: '-84.86' },
        { label: 'Crossville', lat: '35.95', lng: '-85.03' },
        { label: 'Chattanooga', lat: '35.06', lng: '-85.25' },
        { label: 'Nashville', lat: '36.17', lng: '-86.78' },
        { label: 'Cookeville', lat: '36.15', lng: '-85.5' }
      ]
    },
    {
      label: 'Texas',
      value: 'TX',
      city: [
        { label: 'Dallas', lat: '32.79', lng: '-96.76' },
        { label: 'Houston', lat: '29.76', lng: '-95.38' },
        { label: 'Mclean', lat: '35.23', lng: '-100.6' },
        { label: 'Mcqueeney', lat: '29.59', lng: '-98.04' },
        { label: 'Mcfaddin', lat: '28.51', lng: '-97.01' },
        { label: 'Pineland', lat: '31.24', lng: '-93.97' },
        { label: 'Mckinney', lat: '33.2', lng: '-96.65' },
        { label: 'Mcallen', lat: '26.21', lng: '-98.23' },
        { label: 'Lubbock', lat: '33.57', lng: '-101.87' },
        { label: 'Huntsville', lat: '30.71', lng: '-95.54' },
        { label: 'New Boston', lat: '33.46', lng: '-94.41' },
        { label: 'Austin', lat: '30.26', lng: '-97.74' },
        { label: 'Laredo', lat: '27.53', lng: '-99.48' },
        { label: 'Nacogdoches', lat: '31.61', lng: '-94.65' },
        { label: 'North Richland Hills', lat: '32.81', lng: '-97.27' },
        { label: 'Cresson', lat: '32.53', lng: '-97.65' },
        { label: 'El Paso', lat: '31.84', lng: '-106.43' },
        { label: 'San Antonio', lat: '29.45', lng: '-98.5' },
        { label: 'Fort Worth', lat: '32.75', lng: '-97.33' }
      ]
    },
    {
      label: 'Utah',
      value: 'UT',
      city: [
        { label: 'Salt Lake City', lat: '40.75', lng: '-111.9' },
        { label: 'Bountiful', lat: '40.88', lng: '-111.82' },
        { label: 'Midvale', lat: '40.6', lng: '-111.88' },
        { label: 'Aurora', lat: '38.91', lng: '-111.93' },
        { label: 'American Fork', lat: '40.39', lng: '-111.78' },
        { label: 'Park City', lat: '40.64', lng: '-111.49' },
        { label: 'Pleasant Grove', lat: '40.46', lng: '-111.63' },
        { label: 'Bonanza', lat: '40.45', lng: '-109.53' },
        { label: 'Sandy', lat: '40.57', lng: '-111.89' },
        { label: 'Clearfield', lat: '41.11', lng: '-112.05' },
        { label: 'Orem', lat: '40.31', lng: '-111.71' },
        { label: 'Logan', lat: '41.7', lng: '-111.87' },
        { label: 'Cedar City', lat: '37.81', lng: '-113.22' },
        { label: 'Washington', lat: '37.22', lng: '-113.48' },
        { label: 'Saint George', lat: '37.18', lng: '-113.6' },
        { label: 'West Jordan', lat: '40.59', lng: '-112.03' },
        { label: 'Layton', lat: '41.08', lng: '-111.9' },
        { label: 'Ogden', lat: '41.24', lng: '-111.99' },
        { label: 'Provo', lat: '40.22', lng: '-111.69' },
        { label: 'Brigham City', lat: '41.51', lng: '-112.04' }
      ]
    },
    {
      label: 'Vermont',
      value: 'VT',
      city: [
        { label: 'Middletown Springs', lat: '43.48', lng: '-73.12' },
        { label: 'Williston', lat: '44.43', lng: '-73.07' },
        { label: 'Fairlee', lat: '43.91', lng: '-72.19' },
        { label: 'Florence', lat: '43.7', lng: '-73.08' },
        { label: 'Poultney', lat: '43.54', lng: '-73.13' },
        { label: 'Johnson', lat: '44.63', lng: '-72.67' },
        { label: 'Essex Junction', lat: '44.52', lng: '-73.05' },
        { label: 'Rutland', lat: '43.6', lng: '-72.97' },
        { label: 'South Royalton', lat: '43.82', lng: '-72.52' },
        { label: 'Adamant', lat: '44.35', lng: '-72.5' },
        { label: 'Saint Albans', lat: '44.81', lng: '-73.08' },
        { label: 'Colchester', lat: '44.53', lng: '-73.15' },
        { label: 'Sharon', lat: '43.78', lng: '-72.45' },
        { label: 'Barre', lat: '44.2', lng: '-72.5' },
        { label: 'Bennington', lat: '42.87', lng: '-73.18' },
        { label: 'South Burlington', lat: '44.44', lng: '-73.21' },
        { label: 'Bristol', lat: '44.13', lng: '-73.08' },
        { label: 'Montpelier', lat: '44.26', lng: '-72.57' },
        { label: 'Burlington', lat: '44.48', lng: '-73.22' },
        { label: 'Brattleboro', lat: '42.86', lng: '-72.57' }
      ]
    },
    {
      label: 'Virginia',
      value: 'VA',
      city: [
        { label: 'Crystal Hill', lat: '36.85', lng: '-78.9' },
        { label: 'Virginia Beach', lat: '36.73', lng: '-76.04' },
        { label: 'Red Oak', lat: '36.76', lng: '-78.63' },
        { label: 'Rappahannock Academy', lat: '38.15', lng: '-77.3' },
        { label: 'Charlottesville', lat: '38.03', lng: '-78.48' },
        { label: 'Fairfax', lat: '38.86', lng: '-77.05' },
        { label: 'Alexandria', lat: '38.86', lng: '-77.05' },
        { label: 'Skippers', lat: '36.58', lng: '-77.54' },
        { label: 'Richmond', lat: '38.94', lng: '-77.19' },
        { label: 'Natural Bridge', lat: '37.63', lng: '-79.55' },
        { label: 'Culpeper', lat: '38.47', lng: '-78' },
        { label: 'Pulaski', lat: '37.05', lng: '-80.76' },
        { label: 'Arlington', lat: '38.86', lng: '-77.05' },
        { label: 'Lawrenceville', lat: '36.75', lng: '-77.85' },
        { label: 'Norfolk', lat: '36.84', lng: '-76.28' },
        { label: 'Milford', lat: '38.02', lng: '-77.36' },
        { label: 'Roanoke', lat: '37.27', lng: '-79.95' },
        { label: 'Newport News', lat: '37.04', lng: '-76.29' },
        { label: 'Martinsville', lat: '36.68', lng: '-79.86' },
        { label: 'Chesapeake', lat: '36.67', lng: '-76.3' }
      ]
    },
    {
      label: 'Washington',
      value: 'WA',
      city: [
        { label: 'Omak', lat: '48.36', lng: '-119.27' },
        { label: 'Bellevue', lat: '47.61', lng: '-122.21' },
        { label: 'Montesano', lat: '47.17', lng: '-123.6' },
        { label: 'Pasco', lat: '46.41', lng: '-118.9' },
        { label: 'Kirkland', lat: '47.67', lng: '-122.18' },
        { label: 'Forks', lat: '47.79', lng: '-124.26' },
        { label: 'Olympia', lat: '46.97', lng: '-122.87' },
        { label: 'Vancouver', lat: '45.72', lng: '-122.74' },
        { label: 'Yakima', lat: '46.71', lng: '-120.42' },
        { label: 'Carson', lat: '45.79', lng: '-121.89' },
        { label: 'Longview', lat: '46.19', lng: '-123.05' },
        { label: 'Kalama', lat: '46.01', lng: '-122.7' },
        { label: 'Everett', lat: '47.98', lng: '-122.2' },
        { label: 'Bellingham', lat: '48.73', lng: '-122.48' },
        { label: 'Shelton', lat: '47.23', lng: '-123.2' },
        { label: 'Kent', lat: '47.36', lng: '-122.19' },
        { label: 'Lynnwood', lat: '47.8', lng: '-122.28' },
        { label: 'Seattle', lat: '47.61', lng: '-122.33' },
        { label: 'Tacoma', lat: '47.25', lng: '-122.44' },
        { label: 'Spokane', lat: '47.66', lng: '-117.43' }
      ]
    },
    {
      label: 'West Virginia',
      value: 'WV',
      city: [
        { label: 'Dailey', lat: '38.79', lng: '-79.89' },
        { label: 'Nallen', lat: '38.1', lng: '-80.88' },
        { label: 'Buckhannon', lat: '38.98', lng: '-80.22' },
        { label: 'Dixie', lat: '38.26', lng: '-81.18' },
        { label: 'Nitro', lat: '38.41', lng: '-81.83' },
        { label: 'Parsons', lat: '39.09', lng: '-79.67' },
        { label: 'Clarksburg', lat: '39.28', lng: '-80.33' },
        { label: 'Fairmont', lat: '39.48', lng: '-80.14' },
        { label: 'Bluefield', lat: '37.26', lng: '-81.21' },
        { label: 'Mill Creek', lat: '38.73', lng: '-79.97' },
        { label: 'Huntington', lat: '38.41', lng: '-82.43' },
        { label: 'Morgantown', lat: '39.63', lng: '-79.94' },
        { label: 'Winfield', lat: '38.52', lng: '-81.88' },
        { label: 'Elkins', lat: '38.92', lng: '-79.85' },
        { label: 'Princeton', lat: '37.33', lng: '-80.96' },
        { label: 'Wheeling', lat: '40.07', lng: '-80.69' },
        { label: 'Martinsburg', lat: '39.46', lng: '-77.96' },
        { label: 'Parkersburg', lat: '39.26', lng: '-81.54' },
        { label: 'Beckley', lat: '37.78', lng: '-81.18' },
        { label: 'Charleston', lat: '38.35', lng: '-81.63' }
      ]
    },
    {
      label: 'Wisconsin',
      value: 'WI',
      city: [
        { label: 'La Crosse', lat: '43.82', lng: '-91.23' },
        { label: 'Prentice', lat: '45.54', lng: '-90.28' },
        { label: 'Prairie Du Chien', lat: '43.04', lng: '-91.14' },
        { label: 'Brookfield', lat: '43.06', lng: '-88.11' },
        { label: 'Racine', lat: '42.79', lng: '-87.99' },
        { label: 'Waukesha', lat: '42.97', lng: '-88.12' },
        { label: 'New London', lat: '44.39', lng: '-88.73' },
        { label: 'Goodman', lat: '45.63', lng: '-88.34' },
        { label: 'Fox Lake', lat: '43.56', lng: '-88.91' },
        { label: 'Milwaukee', lat: '43.06', lng: '-87.96' },
        { label: 'Waupaca', lat: '44.35', lng: '-89.07' },
        { label: 'Green Bay', lat: '44.43', lng: '-88.07' },
        { label: 'Appleton', lat: '44.26', lng: '-88.39' },
        { label: 'Amherst Junction', lat: '44.46', lng: '-89.31' },
        { label: 'Eau Claire', lat: '44.82', lng: '-91.49' },
        { label: 'Madison', lat: '43.1', lng: '-89.5' },
        { label: 'Hayward', lat: '46.01', lng: '-91.48' },
        { label: 'Kenosha', lat: '42.58', lng: '-87.85' },
        { label: 'Oshkosh', lat: '44.01', lng: '-88.55' },
        { label: 'Janesville', lat: '42.68', lng: '-89.01' }
      ]
    },
    {
      label: 'Wyoming',
      value: 'WY',
      city: [
        { label: 'Powell', lat: '44.79', lng: '-108.73' },
        { label: 'Greybull', lat: '44.49', lng: '-108.05' },
        { label: 'Jackson', lat: '43.47', lng: '-110.76' },
        { label: 'Glenrock', lat: '42.85', lng: '-105.85' },
        { label: 'Evanston', lat: '41.25', lng: '-110.96' },
        { label: 'Gillette', lat: '44.28', lng: '-105.51' },
        { label: 'Cody', lat: '44.51', lng: '-109.05' },
        { label: 'Lovell', lat: '44.83', lng: '-108.39' },
        { label: 'Lander', lat: '42.83', lng: '-108.72' },
        { label: 'Hulett', lat: '44.68', lng: '-104.6' },
        { label: 'Mills', lat: '42.83', lng: '-106.32' },
        { label: 'Upton', lat: '44.1', lng: '-104.62' },
        { label: 'Savery', lat: '41.08', lng: '-107.34' },
        { label: 'Beulah', lat: '44.53', lng: '-104.08' },
        { label: 'Sheridan', lat: '44.79', lng: '-106.95' },
        { label: 'Riverton', lat: '43.03', lng: '-108.41' },
        { label: 'Laramie', lat: '41.58', lng: '-105.69' },
        { label: 'Rock Springs', lat: '41.59', lng: '-109.22' },
        { label: 'Cheyenne', lat: '41.14', lng: '-104.79' },
        { label: 'Casper', lat: '42.83', lng: '-106.32' }
      ]
    }
  ],
  CA: [
    {
      label: 'Alberta',
      value: 'AB',
      city: [
        { label: 'Whitecourt', lat: '54.12804667', lng: '-115.6656933' },
        { label: 'La Crete', lat: '58.2057116', lng: '-116.407196' },
        { label: 'Blue Ridge', lat: '54.127865', lng: '-115.36901' },
        { label: 'Sherwood Park', lat: '53.52454376', lng: '-113.2969379' },
        { label: 'Lloydminster', lat: '53.27794245', lng: '-110.0292778' },
        { label: 'Saint Albert', lat: '53.65442256', lng: '-113.6171691' },
        { label: 'Red Deer', lat: '52.27377725', lng: '-113.8127804' },
        { label: 'Lethbridge', lat: '49.69361739', lng: '-112.8253191' },
        { label: 'Abee', lat: '54.197541', lng: '-113.038456' },
        { label: 'Brooks', lat: '50.57104192', lng: '-111.8957998' },
        { label: 'Hinton', lat: '53.40487898', lng: '-117.5709207' },
        { label: 'Grande Cache', lat: '53.875388', lng: '-119.140267' },
        { label: 'Camrose', lat: '53.01500534', lng: '-112.8345016' },
        { label: 'Boyle', lat: '54.745957', lng: '-112.800267' },
        { label: 'Sundre', lat: '51.79688514', lng: '-114.6398449' },
        { label: 'Fort Mcmurray', lat: '56.71712453', lng: '-111.3967235' },
        { label: 'Medicine Hat', lat: '50.03045462', lng: '-110.6766333' },
        { label: 'Edmonton', lat: '53.53819793', lng: '-113.5029643' },
        { label: 'Calgary', lat: '51.04073332', lng: '-114.0796651' },
        { label: 'Grande Prairie', lat: '55.16844474', lng: '-118.7918946' }
      ]
    },
    {
      label: 'British Columbia',
      value: 'BC',
      city: [
        { label: 'Cranbrook', lat: '49.50767525', lng: '-115.7627396' },
        { label: 'Richmond', lat: '49.16986397', lng: '-123.1363106' },
        { label: 'Fort St James', lat: '54.4561191', lng: '-124.2620659' },
        { label: 'Chase', lat: '50.81891', lng: '-119.684097' },
        { label: 'Prince George', lat: '53.91717991', lng: '-122.7499008' },
        { label: 'North Vancouver', lat: '49.32973307', lng: '-123.0581737' },
        { label: 'Victoria', lat: '48.42680849', lng: '-123.3622169' },
        { label: 'Salt Spring Island', lat: '48.84972637', lng: '-123.5029476' },
        { label: 'Williams Lake', lat: '52.13320993', lng: '-122.1396323' },
        { label: 'White Rock', lat: '49.02453084', lng: '-122.8012276' },
        { label: 'Creston', lat: '49.09749836', lng: '-116.5116646' },
        { label: 'Burnaby', lat: '49.2457939', lng: '-122.9761727' },	
        { label: 'Delta', lat: '49.15521508', lng: '-122.9122925' },
        { label: 'Abbotsford', lat: '49.05227278', lng: '-122.3059515' },
        { label: 'Kamloops', lat: '50.67584778', lng: '-120.3377151' },
        { label: 'Langley', lat: '49.10594988', lng: '-122.6371888' },
        { label: 'Salmon Arm', lat: '50.6999914', lng: '-119.2856884' },
        { label: 'Kelowna', lat: '49.88681', lng: '-119.4966' },
        { label: 'Vancouver', lat: '49.25397621', lng: '-123.1080914' },
        { label: 'Surrey', lat: '49.13635335', lng: '-122.8213433' }
      ]
    },
    {
      label: 'Manitoba',
      value: 'MB',
      city: [
        { label: 'Fraserwood', lat: '50.63941663', lng: '-97.21506768' },
        { label: 'Thompson', lat: '55.74532785', lng: '-97.85136223' },
        { label: 'Swan River', lat: '52.105609', lng: '-101.2712002' },
        { label: 'Dauphin', lat: '51.14958729', lng: '-100.0473853' },
        { label: 'Tilston', lat: '49.39361304', lng: '-101.313707' },
        { label: 'Selkirk', lat: '50.14544629', lng: '-96.87263489' },
        { label: 'Kinosota', lat: '50.933579', lng: '-98.897335' },
        { label: 'The Pas', lat: '53.82269575', lng: '-101.2518024' },
        { label: 'Cormorant', lat: '54.208596', lng: '-100.604341' },
        { label: 'Portage La Prairie', lat: '49.97269837', lng: '-98.29072952' },
        { label: 'Belair', lat: '50.583296', lng: '-96.569921' },
        { label: 'Brandon', lat: '49.84227168', lng: '-99.95456922' },
        { label: 'Pierson', lat: '49.18002671', lng: '-101.2633859' },
        { label: 'Carberry', lat: '49.86892508', lng: '-99.36020722' },
        { label: 'Steinbach', lat: '49.52972096', lng: '-96.68981552' },
        { label: 'South Junction', lat: '49.012597', lng: '-95.788503' },
        { label: 'Piney', lat: '49.07493419', lng: '-95.97853661' },
        { label: 'Angusville', lat: '50.7355967', lng: '-101.0214872' },
        { label: 'Winkler', lat: '49.18153507', lng: '-97.93942451' },
        { label: 'Winnipeg', lat: '49.89529789', lng: '-97.13888168' }
      ]
    },
    {
      label: 'New Brunswick',
      value: 'NB',
      city: [	
        { label: 'Dieppe', lat: '46.08627002', lng: '-64.72339472' },
        { label: 'Cherry Burton', lat: '45.92548833', lng: '-64.44415825' },
        { label: 'Woodstock', lat: '46.14998899', lng: '-67.57235527' },
        { label: 'Maple View', lat: '46.87819414', lng: '-67.58036771' },
        { label: 'Ammon', lat: '46.168897', lng: '-64.841025' },
        { label: 'Bathurst', lat: '47.62538445', lng: '-65.66225959' },
        { label: 'Sussex', lat: '45.7231394', lng: '-65.5095005' },
        { label: 'Moncton', lat: '46.10171273', lng: '-64.80140711' },
        { label: 'Riverview', lat: '46.06346454', lng: '-64.80294228' },
        { label: 'Campbellton', lat: '48.00060449', lng: '-66.67423902' },
        { label: 'Pont Lafrance', lat: '47.54502081', lng: '-65.38250209' },
        { label: 'Napan', lat: '46.93671514', lng: '-65.51649639' },
        { label: 'Miramichi', lat: '47.02760481', lng: '-65.46907425' },
        { label: 'Fredericton', lat: '45.95936258', lng: '-66.64624147' },
        { label: 'Pabineau First Nation', lat: '45.67772012', lng: '-65.95152118' },
        { label: 'Letang', lat: '45.1109373', lng: '-66.84100422' },
        { label: 'Saint-louis', lat: '46.73039361', lng: '-65.36734945' },
        { label: 'Lakeville Corner', lat: '46.01699276', lng: '-66.0711397' },
        { label: 'Saint John', lat: '45.27265161', lng: '-66.06233597' },
        { label: 'Edmundston', lat: '47.37518016', lng: '-68.33297135' }
      ]
    },
    {
      label: 'Newfoundland and Labrador',
      value: 'NL',
      city: [
        { label: 'Clarenville', lat: '48.16759805', lng: '-53.97260608' },
        { label: 'Port Saunders', lat: '50.632391', lng: '-57.270619' },
        { label: 'Stephenville', lat: '48.5501374', lng: '-58.57446671' },
        { label: 'Badgers Quay', lat: '48.551919', lng: '-58.567838' },
        { label: 'Labrador City', lat: '52.93977918', lng: '-66.92055103' },
        { label: 'Mount Pearl', lat: '47.51572974', lng: '-52.80909427' },
        { label: 'Conception Bay South', lat: '47.50516293', lng: '-52.98207831' },
        { label: 'Marystown', lat: '47.1666341', lng: '-55.14829246' },
        { label: 'Main Brook', lat: '51.18125', lng: '-56.031541' },
        { label: 'Grand Falls-windsor', lat: '48.94013364', lng: '-55.65318865' },
        { label: 'Corner Brook', lat: '48.95095838', lng: '-57.95661567' },
        { label: 'Cow Head', lat: '49.91254559', lng: '-57.79306412' },
        { label: 'West Bay Centre', lat: '48.61441', lng: '-58.979702' },
        { label: 'Bay Roberts', lat: '47.59869741', lng: '-53.2568264' },
        { label: 'Gander', lat: '48.96088924', lng: '-54.61150408' },
        { label: 'Little St Lawrence', lat: '46.925471', lng: '-55.357411' },
        { label: 'Carbonear', lat: '47.73599824', lng: '-53.22301396' },
        { label: 'Chapel Arm', lat: '47.507104', lng: '-53.649304' },
        { label: 'Triton', lat: '49.52197683', lng: '-55.61313629' }
      ]
    },
    {
      label: 'Northwest Territories',
      value: 'NT',
      city: [
        { label: 'Hay River', lat: '60.82058', lng: '-115.78217' },
        { label: 'Aklavik', lat: '68.222675', lng: '-135.017605' },
        { label: 'Tuktoyaktuk', lat: '69.443224', lng: '-133.03722' },
        { label: 'Fort Smith', lat: '60.015652', lng: '-111.889503' },
        { label: 'Sachs Harbour', lat: '71.98827909', lng: '-125.2395916' },
        { label: 'Fort Resolution', lat: '61.170126', lng: '-113.66459' },
        { label: 'Inuvik', lat: '68.366995', lng: '-133.729184' },
        { label: 'Rae Edzo', lat: '62.825373', lng: '-116.063757' },
        { label: 'Fort Liard', lat: '60.235895', lng: '-123.462936' },
        { label: 'Wrigley', lat: '63.230575', lng: '-123.468663' },
        { label: 'Tsiigehtchic', lat: '67.440227', lng: '-133.746807' },
        { label: 'Tulita', lat: '64.915502', lng: '-125.461448' },
        { label: 'Yellowknife', lat: '62.45513715', lng: '-114.3682766' },
        { label: 'Fort Providence', lat: '61.351716', lng: '-117.644001' },
        { label: 'Fort Mcpherson', lat: '67.432219', lng: '-134.866502' },
        { label: 'Fort Good Hope', lat: '66.25609', lng: '-128.636169' },
        { label: 'Fort Simpson', lat: '61.864099', lng: '-121.3594' },
        { label: 'Paulatuk', lat: '69.34340494', lng: '-124.0750408' },
        { label: 'Norman Wells', lat: '65.2820105', lng: '-126.832902' },
        { label: 'Colville Lake', lat: '67.008292', lng: '-126.014477' },
      ]
    },
    {
      label: 'Nova Scotia',
      value: 'NS',
      city: [	
        { label: 'Arichat', lat: '45.514793', lng: '-60.966046' },
        { label: 'Newtown', lat: '45.36684702', lng: '-62.13189158' },
        { label: 'Belle Cote', lat: '46.440054', lng: '-61.09231' },
        { label: 'Granville Ferry', lat: '44.75015144', lng: '-65.5155328' },
        { label: 'Truro', lat: '45.36475016', lng: '-63.27927589' },
        { label: 'Halifax', lat: '44.65481307', lng: '-63.60159372' },
        { label: 'Mosers River', lat: '44.973155', lng: '-62.155062' },
        { label: 'Sydney Forks', lat: '46.04925393', lng: '-60.29747121' },
        { label: 'Antigonish', lat: '45.62323227', lng: '-62.0022839' },
        { label: 'Lower Sackville', lat: '44.773363', lng: '-63.680891' },
        { label: 'New Glasgow', lat: '45.58837061', lng: '-62.64538951' },
        { label: 'Bridgewater', lat: '44.37585159', lng: '-64.51830203' },
        { label: 'Amherst', lat: '45.82755184', lng: '-64.20181275' },
        { label: 'Sydney', lat: '5E3	46.13494326', lng: '-60.19083023' },
        { label: 'Bedford', lat: '44.72445235', lng: '-63.67047031' },
        { label: 'Yarmouth', lat: '43.83297893', lng: '-66.11958504' },
        { label: 'Cherry Brook', lat: '44.710612', lng: '-63.483775' },
        { label: 'Reserve Mines', lat: '46.18399286', lng: '-60.02590077' },
        { label: 'Williamswood', lat: '44.5488457', lng: '-63.64530973' },
        { label: 'Dartmouth', lat: '44.67972207', lng: '-63.54120572' }
      ]
    },
    {
      label: 'Nunavut',
      value: 'NU',
      city: [
        { label: 'Arviat', lat: '61.10800543', lng: '-94.0576458' },
        { label: 'Clyde River', lat: '70.464264', lng: '-68.478887' },
        { label: 'Coral Harbour', lat: '64.1333333', lng: '-83.1666667' },
        { label: 'Igloolik', lat: '69.38345604', lng: '-81.79767609' },
        { label: 'Rankin Inlet', lat: '62.8166667', lng: '-92.0833333' },
        { label: 'Baker Lake', lat: '64.3166667', lng: '-96.0166667' },
        { label: 'Pangnirtung', lat: '66.144834', lng: '-65.675701' },
        { label: 'Hall Beach', lat: '68.777173', lng: '-81.251416' },
        { label: 'Arctic Bay', lat: '73.06083', lng: '-84.982737' },
        { label: 'Kugluktuk', lat: '67.82505', lng: '-115.09528' },
        { label: 'Kugaaruk', lat: '68.5333333', lng: '-89.8166667' },
        { label: 'Cape Dorset', lat: '64.228265', lng: '-76.542169' },
        { label: 'Cambridge Bay', lat: '69.11428', lng: '-105.05755' },
        { label: 'Taloyoak', lat: '69.5333333', lng: '-93.5333333' },
        { label: 'Whale Cove', lat: '62.1833333', lng: '-92.6' },
        { label: 'Iqaluit', lat: '63.75145', lng: '-68.51898' },
        { label: 'Qikiqtarjuaq', lat: '67.5586', lng: '-64.0236' },
        { label: 'Repulse Bay', lat: '66.5166667', lng: '-86.2333333' },
        { label: 'Sanikiluaq', lat: '56.54404', lng: '-79.2223' }
      ]
    },
    {
      label: 'Ontario',
      value: 'ON',
      city: [
        { label: 'Mississauga', lat: '43.58700668', lng: '-79.66958605' },
        { label: 'North York', lat: '43.75166549', lng: '-79.42622482' },
        { label: 'Chatham', lat: '42.40502354', lng: '-82.1876408' },
        { label: 'Napanee', lat: '44.24717832', lng: '-76.9544656' },
        { label: 'Saint Catharines', lat: '43.15861151', lng: '-79.24515724' },
        { label: 'Chapleau', lat: '47.837821', lng: '-83.406028' },
        { label: 'Etobicoke', lat: '43.66416235', lng: '-79.54528152' },
        { label: 'Madawaska', lat: '45.50012397', lng: '-77.98282148' },
        { label: 'Aylmer', lat: '42.77132798', lng: '-80.98450296' },
        { label: 'Peterborough', lat: '44.30217275', lng: '-78.33156067' },
        { label: 'Burlington', lat: '43.35166441', lng: '-79.80125295' },
        { label: 'Hamilton', lat: '43.23835191', lng: '-79.84985429' },
        { label: 'Brantford', lat: '43.15149715', lng: '-80.2618235' },
        { label: 'Scarborough', lat: '43.76917531', lng: '-79.24626239' },
        { label: 'London', lat: '42.98079059', lng: '-81.24698294' },
        { label: 'Cambridge', lat: '43.38124222', lng: '-80.32118531' },
        { label: 'Sault Ste Marie', lat: '46.52381652', lng: '-84.32731192' },
        { label: 'Ottawa', lat: '45.39334781', lng: '-75.69561003' },
        { label: 'Brampton', lat: '43.70658627', lng: '-79.75288838' },
        { label: 'Toronto', lat: '43.67090582', lng: '-79.39333119' }
      ]
    },
    {
      label: 'Prince Edward Island',
      value: 'PE',
      city: [
        { label: 'Souris', lat: '46.35451084', lng: '-62.25282669' },
        { label: 'Alberton', lat: '46.813101', lng: '-64.061952' },
        { label: 'Belle River', lat: '45.980595', lng: '-62.807587' },
        { label: 'Charlottetown', lat: '46.25223695', lng: '-63.13278611' },
        { label: 'Kinkora', lat: '46.32298', lng: '-63.601308' },
        { label: 'Morell', lat: '46.41573051', lng: '-62.7045536' },
        { label: 'Montague', lat: '46.1653215', lng: '-62.648879' },
        { label: 'Tignish', lat: '46.95043801', lng: '-64.03321266' },
        { label: 'Hunter River', lat: '46.35012385', lng: '-63.34869901' },
        { label: 'Slemon Park', lat: '46.433559', lng: '-63.823634' },
        { label: 'Stratford', lat: '46.22165246', lng: '-63.08469772' },
        { label: 'Cornwall', lat: '46.22741237', lng: '-63.21730614' },
        { label: 'Wellington Station', lat: '46.4501416', lng: '-63.99873571' },
        { label: 'Murray River', lat: '46.01645598', lng: '-62.61408806' },
        { label: 'Central Bedeque', lat: '46.335551', lng: '-63.704187' },
        { label: 'Port Borden', lat: '46.25', lng: '-63.7' },
        { label: 'Kensington', lat: '46.4356505', lng: '-63.637783' },
        { label: 'Bonshaw', lat: '46.194766', lng: '-63.353488' },
        { label: 'Freetown', lat: '46.396245', lng: '-63.562365' },
        { label: 'Summerside', lat: '46.39264798', lng: '-63.79159927' }
      ]
    },
    {
      label: 'Quebec',
      value: 'QC',
      city: [
        { label: 'Lac-des-iles', lat: '46.40300674', lng: '-75.53375244' },
        { label: 'Longueuil', lat: '45.5303877', lng: '-73.4805959' },
        { label: 'Montmagny', lat: '46.97890132', lng: '-70.55720275' },
        { label: 'Chicoutimi', lat: '48.420788', lng: '-71.066005' },
        { label: 'Cadillac', lat: '48.223515', lng: '-78.384631' },
        { label: 'Gatineau', lat: '45.47680416', lng: '-75.70034981' },
        { label: 'Hull', lat: '45.44391699', lng: '-75.74311345' },
        { label: 'La Malbaie', lat: '47.66648748', lng: '-70.1385295' },
        { label: 'Saint-leonard', lat: '45.58334983', lng: '-73.59191895' },
        { label: 'Maniwaki', lat: '46.37651017', lng: '-75.97438357' },
        { label: 'Sainte-foy', lat: '46.77423362', lng: '-71.31459121' },
        { label: 'Trois-riviEres', lat: '46.35083784', lng: '-72.54547119' },
        { label: 'Saint-laurent', lat: '45.50911386', lng: '-73.6941433' },
        { label: 'Amos', lat: '48.57231636', lng: '-78.11707787' },
        { label: 'Bois-franc', lat: '46.466609', lng: '-75.982148' },
        { label: 'Montreal', lat: '45.53648241', lng: '-73.59270158' },
        { label: 'Saint-hyacinthe', lat: '45.62664388', lng: '-72.94278145' },
        { label: 'Laval', lat: '45.58094581', lng: '-73.74271361' },
        { label: 'Sherbrooke', lat: '45.40008464', lng: '-71.90784066' }
      ]
    },
    {
      label: 'Saskatchewan',
      value: 'SK',
      city: [
        { label: 'Estevan', lat: '49.14317027', lng: '-102.9920704' },
        { label: 'Kindersley', lat: '51.46681149', lng: '-109.1681827' },
        { label: 'Black Lake', lat: '59.13385294', lng: '-105.6016248' },
        { label: 'Melfort', lat: '52.86089105', lng: '-104.6161938' },
        { label: 'Yorkton', lat: '51.21016348', lng: '-102.4730873' },
        { label: 'Swift Current', lat: '50.28742103', lng: '-107.7972147' },
        { label: 'Humboldt', lat: '52.201393', lng: '-105.134075' },
        { label: 'North Battleford', lat: '52.78034608', lng: '-108.2933687' },
        { label: 'Tisdale', lat: '52.85617514', lng: '-104.0441322' },
        { label: 'Deschambault Lake', lat: '54.912216', lng: '-103.371051' },
        { label: 'Heward', lat: '49.737943', lng: '-103.155472' },
        { label: 'Alameda', lat: '49.26674879', lng: '-102.2841983' },
        { label: 'Weyburn', lat: '49.66324159', lng: '-103.8476876' },
        { label: 'Christopher Lake', lat: '53.540677', lng: '-105.787128' },
        { label: 'Frenchman Butte', lat: '53.59917776', lng: '-109.6352291' },
        { label: 'Prince Albert', lat: '53.1958569', lng: '-105.7432137' },
        { label: 'Saskatoon', lat: '52.13082378', lng: '-106.6532757' },
        { label: 'Moose Jaw', lat: '50.39521619', lng: '-105.5483545' },
        { label: 'Meadow Lake', lat: '54.12712384', lng: '-108.4339906' },
        { label: 'Regina', lat: '50.44690187', lng: '-104.6176529' }
      ]
    },
    {
      label: 'Yukon',
      value: 'YT',
      city: [
        { label: 'Old Crow', lat: '67.573837', lng: '-139.821106' },
        { label: 'Marsh Lake', lat: '60.63810533', lng: '-134.347363' },
        { label: 'Teslin', lat: '60.16845735', lng: '-132.7160454' },
        { label: 'Dawson', lat: '64.06166901', lng: '-139.4313993' },
        { label: 'Beaver Creek', lat: '62.359909', lng: '-140.869507' },
        { label: 'Whitehorse', lat: '60.71934635', lng: '-135.0526142' },
        { label: 'Ross River', lat: '61.983351', lng: '-132.464064' },
        { label: 'Faro', lat: '62.225604', lng: '-133.338937' },
        { label: 'Burwash Landing', lat: '61.349198', lng: '-139.026104' },
        { label: 'Destruction Bay', lat: '61.249591', lng: '-138.814619' },
        { label: 'Tagish', lat: '60.31331006', lng: '-134.2717283' },
        { label: 'Pelly Crossing', lat: '62.82901451', lng: '-136.5829754' },
        { label: 'Watson Lake', lat: '60.068901', lng: '-128.7034' },
        { label: 'Carmacks', lat: '62.08835288', lng: '-136.2929464' },
        { label: 'Haines Junction', lat: '60.75215725', lng: '-137.5108228' },
        { label: 'Carcross', lat: '60.168652', lng: '-134.707678' },
        { label: 'Mayo', lat: '63.597731', lng: '-135.858182' }
      ]
    }
  ]
}


// WEBPACK FOOTER //
// ./src/misc/country-info.js